import { useMutation } from '@apollo/client';
import type { CreateCustomerGroup, CreateCustomerGroupInput, CreateCustomerGroupVariables } from 'types/graphql';
import { CUSTOMER_GROUP_PAGE_QUERY } from './useCustomerGroups';

const CREATE_CUSTOMER_GROUPS = gql`
  mutation CreateCustomerGroup($input: CreateCustomerGroupInput!) {
    createCustomerGroup(input: $input) {
      id
    }
  }
`;

export default function useCreateCustomerGroup() {
  const [createCustomerGroup] = useMutation<CreateCustomerGroup, CreateCustomerGroupVariables>(CREATE_CUSTOMER_GROUPS, {
    refetchQueries: [CUSTOMER_GROUP_PAGE_QUERY],
  });
  return async (input: CreateCustomerGroupInput) => {
    const res = await createCustomerGroup({ variables: { input } });
    return res.data?.createCustomerGroup?.id as number;
  };
}
